import {LogLevel, BrowserCacheLocation} from "@azure/msal-browser";

const AZURE_AUTHORITY = process.env.REACT_APP_AZURE_AUTHORITY;
const AZURE_CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID ?? "";
const REDIRECT_URI = process.env.REACT_APP_AZURE_REDIRECT_URI;

export const msalConfig = {
    auth: {
        clientId: AZURE_CLIENT_ID,
        authority: "https://" + AZURE_AUTHORITY + ".b2clogin.com/" + AZURE_AUTHORITY + ".onmicrosoft.com/b2c_1a_signup_signin_mobile",
        knownAuthorities: ["https://" + AZURE_AUTHORITY + ".b2clogin.com"],
        redirectUri: REDIRECT_URI,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: true
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        return;
                    case LogLevel.Verbose:
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};